import { FC } from 'react';
import { Title } from 'UI';
import styles from './ApprovalPanel.module.scss';

type ApprovalPanelProps = {
  title: string;
  description: string;
};

const ApprovalPanel: FC<ApprovalPanelProps> = ({ title, description }) => (
  <div className={styles.ContainerPanel}>
    <Title level="5" className={styles.title}>
      {title}:
    </Title>
    <Title level="5" className={styles.title} emphasized={false}>
      {description}
    </Title>
  </div>
);

export default ApprovalPanel;
